import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { config, isConfigValid } from '@/app/config';
import { useAppStore } from '@/app/store';
import { AppShell } from '@/components/layout/AppShell';
import { Spinner } from '@/components/ui/Spinner';
import { LandingPage } from '@/pages/landing/LandingPage';
import { AuthPage } from '@/pages/auth/AuthPage';
import { PrivacyPage } from '@/pages/legal/PrivacyPage';
import { TermsPage } from '@/pages/legal/TermsPage';
import { ConfigErrorPage } from '@/pages/app/ConfigErrorPage';

function RequireAuth() {
  const ready = useAppStore((s) => s.ready);
  const session = useAppStore((s) => s.session);
  const location = useLocation();

  if (!ready) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', height: '100%' }}>
        <Spinner />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/app/auth" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}

function AppGuard() {
  if (config.mode === 'production' && !isConfigValid(config)) {
    return <ConfigErrorPage />;
  }
  return <Outlet />;
}

export function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/app/auth" element={<AuthPage />} />
        <Route path="/app/join/:code?" element={<AuthPage />} />
        <Route path="/app/*" element={<AppGuard />}>
          <Route element={<RequireAuth />}>
            <Route path="*" element={<AppShell />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
